import { render } from "./FlowsSharedOnlyBanner.vue?vue&type=template&id=74cd9731"
import script from "./FlowsSharedOnlyBanner.vue?vue&type=script&lang=js"
export * from "./FlowsSharedOnlyBanner.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__